module.exports = __webpack_public_path__ + "img/narrow.2e8464cb.svg";